var map = {
	"./1.jpg": 7429,
	"./2.jpg": 3224,
	"./2.png": 3825,
	"./3.jpeg": 8304,
	"./3.jpg": 1097,
	"./4.jpeg": 1112,
	"./5.jpeg": 9437,
	"./5.jpg": 5909,
	"./6.jpeg": 2916,
	"./6.jpg": 4904,
	"./7.jpeg": 7914,
	"./7.jpg": 8754,
	"./8.jpg": 8927,
	"./WhatsApp Image 2022-03-02 at 11.05.20 AM (1).jpeg": 4805,
	"./hh.jpeg": 764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9740;